export const localStorageKeys = {
    currentUser: 'currentUser', // store User object
    pwa: 'pwa', // store PwaStore object
    oAuthStateParameter: 'oAuthStateParameter', // store oAuth2 State Parameter
    isRefreshingTokens: 'isRefreshingTokens', // store the fact that a tab is refreshing tokens
};
